// Make this footer responsive for mobile and desktop using SCSS
//                       <b>Web:</b>
//                       <span>www.2x4.de</span>
//             labels={[
//import { useState, useEffect, useCallback, Fragment } from 'react';
import { FunctionComponent } from "react";
//import { useNavigate } from 'react-router-dom';
import "./footer.scss";
import MenuItem from "../top-menu/menu-item";
import B from "../html-tags/b";
import LI from "../html-tags/li";
import DIV from "../html-tags/div";
import SubMenuItem from "../sub-menu/sub-menu-item";

export type Props = { hideCookieSettings?: boolean };

const Footer: FunctionComponent<Props> = (props) => {
  //const history = useNavigate();

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      <div className="footer">
        <div className="footer-details">
          <div className="address">
            <B language="de" className="column-header">
              Firmeninfo
            </B>
            <B language="en" className="column-header">
              Company
            </B>
            <br />
            2x4 Solutions GmbH
            <br />
            Fichtenring 8 | 84562 Mettenheim | Germany
            <br />
            <a href="https://www.2x4.de" target="_blank" rel="noreferrer">
              www.2x4.de
            </a>
            {" | "}
            <a
              href="https://predictivesolutions.2x4.de"
              target="_blank"
              rel="noreferrer"
            >
              predictivesolutions.2x4.de
            </a>
          </div>
          <div className="legal-links">
            <B language="de" className="column-header">
              Rechtliche Informationen
            </B>
            <B language="en" className="column-header">
              Legal
            </B>
            <ul>
              {/* = Legal =============================================================== */}
              <MenuItem
                menuName={"legal"}
                labels={[
                  { language: "de", label: "Impressum" },
                  { language: "en", label: "Site Notice" },
                ]}
              />

              {/* = Privacy ============================================================= */}
              <MenuItem
                menuName={"privacy"}
                labels={[
                  { language: "de", label: "Datenschutzerklärung" },
                  { language: "en", label: "Privacy Policy" },
                ]}
              />

              {/* = Cookies ============================================================= */}
              {props.hideCookieSettings !== true && (
                <MenuItem
                  menuName={"cookies"}
                  labels={[
                    { language: "de", label: "Cookie Einstellungen" },
                    { language: "en", label: "Cookie Settings" },
                  ]}
                />
              )}
            </ul>
          </div>

          <div className="segments-links">
            <b className="column-header">Show Cases</b>
            <ul>
              {/* ===================================================================== */}
              <SubMenuItem
                menuName={"showcases/businessintelligence"}
                labels={[
                  { language: "de", label: "Business Intelligence" },
                  { language: "en", label: "Business Intelligence" },
                ]}
              />

              {/* ================================================================= */}
              <SubMenuItem
                menuName={"showcases/marketresearch"}
                labels={[
                  { language: "de", label: "Marktforschung" },
                  { language: "en", label: "Market Research" },
                ]}
              />

              {/* ================================================================ */}
              <SubMenuItem
                menuName={"showcases/healthcare"}
                labels={[
                  { language: "de", label: "Gesundheitswesen" },
                  { language: "en", label: "Healthcare" },
                ]}
              />

              {/* =================================================================== */}
              <SubMenuItem
                menuName={"showcases/politics"}
                labels={[
                  { language: "de", label: "Politik" },
                  { language: "en", label: "Politics" },
                ]}
              />

              {/* ================================================================ */}
              <SubMenuItem
                menuName={"showcases/finance"}
                labels={[
                  { language: "de", label: "Finanzwesen" },
                  { language: "en", label: "Finance" },
                ]}
              />
              {/* ========================================================================== */}
              <SubMenuItem
                menuName={"showcases/productquality"}
                labels={[
                  { language: "de", label: "Produkt & Qualitätsmanagemnt" },
                  { language: "en", label: "product quality management" },
                ]}
              />
              {/* ===================================================================== */}
              <SubMenuItem
                menuName={"showcases/education"}
                labels={[
                  { language: "de", label: "Bildung" },
                  { language: "en", label: "Education" },
                ]}
              />
              {/* ===================================================================== */}
              <SubMenuItem
                menuName={"showcases/municipaladministration"}
                labels={[
                  { language: "de", label: "Kommunale Verwaltung" },
                  { language: "en", label: "Municipal Administration" },
                ]}
              />
            </ul>
          </div>

          <div className="other-links">
            <b className="column-header">Links</b>
            <ul>
              {/* = Features ================================================================ */}
              <MenuItem
                menuName={"features"}
                labels={[
                  { language: "de", label: "Features" },
                  { language: "en", label: "Features" },
                ]}
              />
              {/* = Free Trial ============================================================== */}
              <MenuItem
                menuName={"freetrial"}
                labels={[
                  { language: "de", label: "Kostenloser Test" },
                  { language: "en", label: "Free Trial" },
                ]}
              />
              {/* = Prices ================================================================== */}
              <MenuItem
                menuName={"prices"}
                labels={[
                  { language: "de", label: "Preise" },
                  { language: "en", label: "Prices" },
                ]}
              />
              {/* = Education =============================================================== */}
              <MenuItem
                menuName={"education"}
                labels={[
                  { language: "de", label: "Lernen" },
                  { language: "en", label: "Education" },
                ]}
              />{" "}
              {/* = Contact ================================================================= */}
              <MenuItem
                menuName={"contact"}
                labels={[
                  { language: "de", label: "Kontakt" },
                  { language: "en", label: "Contact" },
                ]}
              />
              {/* = News ==================================================================== */}
              <MenuItem
                menuName={"news"}
                labels={[
                  { language: "de", label: "News" },
                  { language: "en", label: "News" },
                ]}
              />
            </ul>
          </div>
        </div>
      </div>
      <div className="vat-line">
        <DIV language="de" className="vat-line-inner">
          Kein Verkauf an Privatpersonen. Alle angezeigten Preise zzgl. USt. Bei
          Verkauf in EU Länder außerhalb Deutschlands verwenden wir das
          umgekehrte USt Verfahren, wenn uns eine gültige UST-ID des Kunden
          vorliegt. Bei Firmenkunden außerhalb der EU fällt keine USt an.
        </DIV>
        <DIV language="en" className="vat-line-inner">
          No sales to private individuals. All displayed prices are excluding
          VAT. For sales within EU countries outside of Germany, we apply the
          reverse VAT machanism if a valid VAT ID is provided by the customer.
          For corporate customers outside the EU, no VAT is charged.
        </DIV>
      </div>
      <div className="copyright-line">
        &copy; 2013-{new Date().getFullYear().toString()} - 2x4 Solutions GmbH
      </div>
    </>
  );
};

export default Footer;
